import { FC } from 'react'

const Footer: FC = () => {
	return (
		<div className='flex flex-col justify-center items-center mt-8 md:flex-row'>
			<span className='m-0 text-sm'>Copyright © 2022 Rastlinjaki Impact</span>
		</div>
	)
}

export default Footer
